// extracted by mini-css-extract-plugin
export default {"card":"NewsCard_card__JFZKH","date":"NewsCard_date__ehE4a","title":"NewsCard_title__avF7b","body":"NewsCard_body__RMPX-","titleLink":"NewsCard_titleLink__SOdV9"};